/******************************************************************************
 mlib-components
 Library for UI components widely used in LB apps.
 (c) Longboard Architectural Products
 ******************************************************************************/
import React__default from 'react';
import AxiosInterceptor from '../../components/AxiosInterceptor/axios-interceptor.js';
import { SnackbarProvider } from '../../components/SnackBar/toast.js';
import { AuthContextProvider } from '../auth-context/auth-context.js';
import { PageContextProvider } from '../page-context/page-context.js';
import { ReloadProvider } from '../reload-context/reload-context.js';
import ErrorHandler from '../../utils/ErrorHandler/error-handler.js';

var MlibComponents = function (_a) {
    var children = _a.children;
    return (React__default.createElement(SnackbarProvider, null,
        React__default.createElement(AuthContextProvider, null,
            React__default.createElement(PageContextProvider, null,
                React__default.createElement(AxiosInterceptor, null,
                    React__default.createElement(ReloadProvider, null,
                        React__default.createElement(ErrorHandler, null, children)))))));
};
var MlibComponents$1 = MlibComponents;

export { MlibComponents, MlibComponents$1 as default };
